// i18n area 'storage' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.hy-AM.meta.json.
import type { enUS } from './storage'

export const hyAM: typeof enUS = {
  storage: {
    pools: {
      title: 'Պահոց',
      createTitle: 'Ստեղծել պահոց',
      path: 'Ուղի',
      pathHint: 'Բացարձակ ուղի թույլատրված root-ի տակ (լռելյայն /var/lib/tvirt/pools/)',
      shared: 'Համօգտագործվող պահոց',
      sharedChip: 'համօգտագործվող',
      sharedVerifiedChip: 'համօգտագործվող · ստուգված',
      sharedVerifiedTooltip: 'Համօգտագործումը ստուգված է. խաչաձև զոնդերը հաստատում են, որ ամեն անդամ տեսնում է մյուսների գրած տվյալները։',
      sharedDisputedChip: 'համօգտագործվող · ՉՍՏՈՒԳՎԱԾ',
      sharedDisputedTooltip: 'Համօգտագործումը ՍՏՈՒԳՎԱԾ ՉԷ',
      sharedDisputedPair: '{observer}-ը չի տեսնում {writer}-ի գրած տվյալները',
      sharedHint: 'Ցանցային ընդհանուր ռեսուրս՝ լոկալ միակցված նույն ուղիով ամեն անդամի վրա — կենդանի միգրացիայի նախապայմանը (հայտարարագրային)։',
      sharedDanger: 'ՎՏԱՆԳ — TVirt-ը ՀԱՎԱՏՈՒՄ Է այս դրոշին. այն միացնելով՝ ամեն անդամ ենթադրում է, որ այս ուղիով տեսնում է ՆՈՒՅՆ բայթերը։ Թղթապանակի վրա, որն ԻՐԱԿԱՆՈՒՄ համօգտագործվող միակցում ՉԷ (NFS/CIFS/կլաստերային ՖՀ), արդյունքը տվյալների վնասում և կորուստ է առաջին իսկ միգրացիայի կամ HA-ի կողմից այլ հանգույցի վրա վերագործարկման ժամանակ։ Միացրեք միայն, եթե ուղին ամեն հանգույցի վրա նույնությամբ միակցված ընդհանուր ռեսուրս է։',
      type: 'Տեսակ',
      capacity: 'Տարողություն',
      provisioned: 'Տրամադրված',
      provisionedOvercommit: 'Պոտենցիալ պարտավորություն տարողությունից ավելի. thin հատորները կարող են աճել մինչև {n} GiB։',
      phase: { ready: 'Պատրաստ', degraded: 'Դեգրադացված', error: 'Սխալ' },

      // Ռաունդ #156 (ստանդարտ երկխոսություն). ԱՄԲՈՂՋԱԿԱՆ մանրամասների
      // երկխոսությունը — ներդիրներ, ըստ դրայվերի կոնֆիգուրացիայի տողերը և դիտարկված մակերեսը:
      tabConfig: 'Կոնֆիգուրացիա',
      tabCapacity: 'Տարողություն և վիճակ',
      cardIdentity: 'Ինքնություն',
      cardPlacement: 'Տեղադրություն',
      cardConnection: 'Միացում',
      usedReal: 'Իրական զբաղվածություն',
      capacityUnknown: 'Հանգույցը դեռ չի հայտնել այս պուլի տարողությունը — այստեղ թվեր չեն հորինվում',
      overcommitHint: 'Տրամադրված է տարողությունից ավելի. լեգիտիմ է thin պուլերի վրա, հետևեք իրական զբաղվածությանը',
      supportedContent: 'Աջակցվող բովանդակություն',
      content: {
        disks: 'Սկավառակներ',
        catalogFiles: 'Կատալոգի ֆայլեր',
        backups: 'Կրկնօրինակներ',
        appVolumes: 'Հավելվածների հատորներ'
      },
      defaultDiskFormat: 'Սկավառակի լռելյայն ձևաչափ',
      reserveGiB: 'Վերապահված ազատ տարածք (GiB)',
      available: 'Հասանելի',
      diskCount: 'Սկավառակներ',
      filesystem: 'Ֆայլային համակարգ',
      observedAt: 'Դիտարկվել է',
      lostAtRow: 'Կորած է հայտարարվել',
      sharedProbeRow: 'Համօգտագործման ստուգում',
      sharedProbeNodes: 'Զոնդավորված հանգույցներ',
      reachableFrom: 'Հայտարարված հասանելիություն',
      reachableFromHint: 'Հանգույցները, որոնցից այս պահոցը պետք է հասանելի լինի։ VM-ը, որի սկավառակները, ISO-ները կամ մետատվյալներն ապրում են այստեղ, չի գործարկվի և չի միգրացվի այս ցուցակից դուրս հանգույցի վրա։ Բոլոր անդամները նախապես ընտրված են — նեղացրեք ըստ ցանկության։ Ավելի ուշ կլաստերին միացող հանգույցը մնում է դուրս, մինչև այն այստեղ ավելացնեք։',
      reachableFromNone: 'հայտարարված չէ',
      reachableFromTags: 'Հասանելիություն ըստ թեգի',
      reachableFromTagsHint: 'թեգ=արժեք ընտրիչ (ստորակետով բաժանված մուտքեր, AND-ով). այս թեգերը կրող ամեն անդամ հայտարարվում է հասանելի — դինամիկ. հանգույցին թեգ դնելը ներս է բերում այն։',
      reachableFromTagsInvalid: 'Անվավեր ձևաչափ — օգտագործեք թեգ=արժեք, ստորակետով բաժանված',
      reachableResolved: 'Լուծված հանգույցներ՝ {nodes}',
      reachableDeclaredNotSeen: 'հայտարարված, բայց համօգտագործման զոնդի կողմից չտեսնված՝ {nodes}',
      reachableSeenNotDeclared: 'տեսնված, բայց չհայտարարված (պարագծից դուրս)՝ {nodes}',
      cephCluster: 'Կառավարվող Ceph կլաստեր',
      appGuardTitle: 'Պահոցն օգտագործվում է հավելվածների կողմից',
      appEphemeralGuard: 'այս պահոցը հավելվածների կլաստերային անցողիկ պուլն է — նախ փոխեք այն Հավելվածներ էջից, հետո ջնջեք։',
      appInUseGuard: 'այստեղ ապրում են հավելվածների root-եր/հատորներ՝ {apps} — նախ տեղափոխեք կամ ջնջեք դրանք։',
      releaseRequiredTitle: "Ջնջե՞լ '{name}'-ը և ազատել նրա պատկերները",
      releaseRequiredBatchTitle: 'Ջնջե՞լ ընտրված storage-ները և ազատել դրանց պատկերները',
      releaseRequiredBody: 'Պատկերների ազատումը ՈՉ ՄԻ բայթ չի ջնջում. գրանցումից հանելը namespace-ը թողնում է սկավառակի վրա, պատկերները պարզապես դադարում են նյութականացված լինել, և scope-երի յուրաքանչյուր հղում գոյատևում է որպես claim — նորից գրանցեք pool-ը, և դրանք կրկին կորդեգրվեն։',
      releaseConfirm: 'Ջնջել և ազատել պատկերները'
    },
    lost: {
      chip: 'Կորած',
      action: 'Հայտարարել կորած',
      confirmTitle: 'Հայտարարել պահոցը կորած',
      confirmSubmit: 'Հայտարարել կորած',
      confirmBody: 'Օպերատորի հաստատում՝ սեփական հայտարարած ռիսկով. այս պահոցին կամ նրա օբյեկտներին ուղղված ամեն հերթագրված կամ ընթացիկ առաջադրանք ԿՁԱԽՈՂՎԻ, ջնջումները կատարվում են միայն գրառումների մակարդակում (ֆայլային համակարգի վրա աշխատանք չկա), և նոր ֆիզիկական աշխատանքը մերժվում է։ Բայթերին երբեք չեն դիպչում — եթե կրիչը վերադառնա կյանքի, նորից գրանցեք այն և գործարկեք սկանավորում՝ ամեն ինչ նորից որդեգրելու համար։',
      error: 'Հաստատումը մերժվեց'
    },
    findings: {
      action: 'Գտնված օբյեկտներ',
      title: 'Գտնված օբյեկտներ',
      empty: 'Պահոցի անվանատարածքում ոչինչ չի գտնվել',
      loadError: 'Չհաջողվեց բեռնել գտնված օբյեկտները',
      actionError: 'Որոշումը մերժվեց',
      colKind: 'Տեսակ',
      colObject: 'Օբյեկտ',
      colConflict: 'Կոնֆլիկտ',
      namespaceNotice:
        'Այս գրացուցակն արդեն նախաստորագրված էր մեկ այլ պահոցի կողմից. ինքնության կնիքը վերագրվել է այս պահոցի կնիքով։ Բովանդակությունը ՉԻ շոշափվել — դիտեք ստորև գտնված օբյեկտները, ներմուծեք ձեզ անհրաժեշտները, ապա փակեք այս ծանուցումը։',
      kind: {
        disk: 'Սկավառակ',
        catalogFile: 'Կատալոգի ֆայլ',
        vmMetadata: 'VM մետատվյալներ',
        namespace: 'Անվանատարածք',
        foreign: 'Օտար',
        volumeGroup: 'Ծավալների խումբ'
      },
      vgAdopt: {
        action: 'Որդեգրել ծավալների խումբը',
        title: 'Որդեգրել ծավալների խումբը',
        intro:
          'Այս սարքն արդեն կրում է TVirt-ի անունով ծավալների խումբ, բայց նրա կնիքը չի անվանում այստեղ գրանցված որևէ storage։ Դա կարող է լինել այն, ինչ ԱՅՍ կլաստերի նախորդ storage-ը թողել է LUN-ի վրա, կամ այն, ինչ ՄԵԿ ԱՅԼ TVirt կլաստեր է թողել տեր փոխած LUN-ի վրա. այստեղից երկու դեպքերը նույնն են երևում, և հենց դրա համար ոչ ոք չի որոշում ձեր փոխարեն։',
        irreversible: 'Նայեք սարքին, կնիքին և անվանը նախքան շարունակելը՝ որդեգրումը հետ չի շրջվում։',
        device: 'Սարք',
        seal: 'Կնիք',
        sealNone: 'չկա (չկա tvirt.storageId պիտակ)',
        renameTo: 'Կվերանվանվի',
        renameNone: 'Առանց վերանվանման՝ անունն արդեն այն է, ինչ բխեցնում է այս storage-ը',
        volumesNote:
          'Ներսի ծավալները ԱՅՍ գործողությամբ չեն որդեգրվում. հաջորդ սկանավորումը դրանք կառաջարկի մեկ առ մեկ՝ որպես սովորական գտնված օբյեկտներ։'
      },
      conflictChip: 'ID-ն արդեն գոյություն ունի',
      dismissedChip: 'Անտեսված',
      adopt: 'Որդեգրել',
      adoptFileTitle: 'Ներմուծել կատալոգի մեջ',
      adoptFileHint: 'Ֆայլերը գոյություն ունեն միայն կատալոգների ներսում. ընտրեք նշանակետ կատալոգը գտնված ֆայլի համար։',
      purge: 'Ջնջել սկավառակից',
      dismiss: 'Անտեսել',
      purgeConfirmTitle: 'Ջնջել սկավառակից',
      purgeConfirmBody: '{id}-ի գտնված բայթերը կհեռացվեն պահոցից։ Գործողությունն անշրջելի է։',
      taskStarted: 'Սկսված է — շարունակվում է որպես ֆոնային առաջադրանք',
      scan: 'Սկանավորել պահոցը',
      scanStarted: 'Սկանավորումը սկսված է…',
      scanDone: 'Սկանավորումն ավարտված է — գտնված օբյեկտները թարմ են'
    },
    reinit: {
      action: 'Կրկին փորձել սկզբնարկումը'
    },
    wizard: {
      addButton: 'Ավելացնել',
      title: 'Ավելացնել պահոց',
      back: 'Ետ',
      continue: 'Շարունակել',
      selectHint: 'Ընտրեք արձանագրություն՝ տեսնելու, թե ինչպես է TVirt-ը այն օգտագործում։',
      roadmap: 'Ճանապարհային քարտեզ',
      server: 'Սերվեր',
      export: 'Արտահանված ուղի',
      share: 'Share',
      username: 'Օգտանուն',
      password: 'Գաղտնաբառ',
      passwordHint: 'Միայն գրելու համար. օգտագործվում է միակցման համար, այլևս երբեք չի ցուցադրվում։',
      credential: 'Հավատարմագրեր',
      credentialManual: 'Մուտքագրել ձեռքով',
      credentialHint: 'Օգտանուն-գաղտնաբառ տեսակի գրառում բանալիների պահոցում — այստեղ մուտքագրելու այլընտրանքը։',
      credentialEmpty: 'Բանալիների պահոցում օգտանուն-գաղտնաբառ տեսակի հավատարմագրեր դեռ չկան — ստեղծեք Համակարգ → Հավատարմագրեր բաժնում, կամ մուտքագրեք հաշիվը ստորև։',
      options: 'Միակցման ընտրանքներ',
      optionsHint: 'Ստորակետով բաժանված, փոխանցվում են mount -o-ին այնպես, ինչպես կան։',
      portal: 'Պորտալ',
      portalHint: 'հոսթ[:պորտ] — լռելյայն պորտը 3260 է։',
      target: 'Target IQN',
      targetHint: 'iSCSI թիրախի անունը, սկսվում է iqn.-ով',
      lun: 'LUN',
      wholeLunRow: 'Սկավառակների վրա. այս պահոցը նշում է միայն target-ը',
      wholeLunHint: 'Այս պահոցը նշում է միայն target-ը. նրա LUN-ները մեկ առ մեկ դառնում են սկավառակներ (Ստեղծել սկավառակ → ընդունել ամբողջ LUN), target-ի վրա ոչինչ չի գրվում։',
      lunHint: 'LUN-ի համարը թիրախի վրա — կասկածի դեպքում՝ 0։',
      chapCredential: 'Հավատարմագրեր (CHAP)',
      chapCredentialHint: 'CHAP (iSCSI) տեսակի գրառում բանալիների պահոցում՝ օգտագործվում է մուտքի համար — գաղտնիքը երբեք չի ճամփորդում պահոցի հետ։',
      chapNone: 'Առանց նույնականացման',
      chapEmpty: 'Բանալիների պահոցում CHAP (iSCSI) տեսակի հավատարմագրեր դեռ չկան — ստեղծեք Համակարգ → Հավատարմագրեր բաժնում։ Առանց դրանց մուտքը մնում է չնույնականացված։',
      address: 'Հասցե',
      addressHint: 'NVMe/TCP թիրախի հոսթը կամ IP-ն (traddr)։',
      port: 'Պորտ',
      portHint: 'Թիրախի TCP պորտը — դատարկ թողնելու դեպքում՝ 4420։',
      targetNqn: 'Target NQN',
      targetNqnHint: 'Ենթահամակարգի NQN-ը թիրախի վրա, սկսվում է nqn.-ով',
      nsid: 'NSID',
      nsidHint: 'Namespace ID-ն ենթահամակարգի ներսում — կասկածի դեպքում՝ 1։',
      dhchapCredential: 'Հավատարմագրեր (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'DH-HMAC-CHAP (NVMe) տեսակի գրառում բանալիների պահոցում՝ օգտագործվում է միացման պահին — գաղտնիքը երբեք չի ճամփորդում պահոցի հետ։',
      dhchapNone: 'Առանց նույնականացման',
      dhchapEmpty: 'Բանալիների պահոցում DH-HMAC-CHAP (NVMe) տեսակի հավատարմագրեր դեռ չկան — ստեղծեք Համակարգ → Հավատարմագրեր բաժնում։ Առանց դրանց միացումը մնում է չնույնականացված։',
      monitors: 'Մոնիտորներ',
      monitorsHint: 'Ceph մոնիտորների վերջնակետեր, հոսթ[:պորտ], ստորակետով կամ նոր տողով բաժանված — լռելյայն պորտը 6789։',
      pool: 'Պուլ',
      poolHint: 'Սպառվող RBD պուլը — մեկ RBD պատկեր ամեն սկավառակի։',
      fs: 'Ֆայլային համակարգ',
      fsHint: 'CephFS ֆայլային համակարգի անունը (mds_namespace միակցման պահին)։',
      fsPath: 'Ուղի ֆայլային համակարգի ներսում',
      fsPathHint: 'Բացարձակ ուղի ֆայլային համակարգի ներսում, որը պահոցը միակցում է — կասկածի դեպքում՝ /։',
      cephxCredential: 'Հավատարմագրեր (cephx)',
      cephxCredentialHint: 'Cephx տեսակի գրառում բանալիների պահոցում. username = կլիենտի անունը (client.…), secret = base64 բանալին։ Պարտադիր է։',
      cephxNone: 'Բանալիների պահոցում cephx հավատարմագրեր դեռ չկան — ստեղծեք մեկը (տեսակ՝ cephx) Համակարգ → Հավատարմագրեր բաժնում, կամ թողեք, որ կառավարվող Ceph կլաստերը գեներացնի այն «Առաջարկել որպես պահոց»-ի միջոցով։',
      sharedByNature: 'Ցանցային պահոցները բնույթով համօգտագործվող են. ամեն անդամ միակցում է դրանք TVirt-ի կառավարած նույն ուղիով։',
      error: 'Պահոցը մերժվեց',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Այլ',
        legacy: 'Legacy'
      },
      legacyHint: 'Լիովին աջակցվում են — պարզապես նոր տեղադրման համար դրանք չէինք ընտրի։',
      proto: {
        // `usage` տողը (Luca 2026-07-24) ասում է, թե ինչպես է TVirt-ը օգտագործում
        // արձանագրությունը — առաջին հերթին թույլատրված բովանդակությունը.
        // dir/nfs/cifs-ը պահում են սկավառակներ ԵՎ ISO/սկավառակի պատկերներ ու
        // ձևանմուշներ, բլոկային դրայվերները (iscsi/nvme-tcp/rbd) ՄԻԱՅՆ սկավառակներ:
        dir: {
          name: 'Լոկալ թղթապանակ',
          desc: 'Հանգույցի վրա գտնվող թղթապանակ. պարզ և արագ։ Այն ԼՈԿԱԼ է մեկ հանգույցի, եթե ուղին իրականում համօգտագործվող միակցում չէ — այն համօգտագործվող նշելը, երբ չէ, արժե տվյալներ։',
          usage: 'TVirt-ն այնտեղ պահում է VM-ների սկավառակներ, ISO/սկավառակի պատկերներ և ձևանմուշներ։'
        },
        nfs: {
          name: 'NFS',
          desc: 'Կլաստերի միակցած NFS արտահանում — բնույթով համօգտագործվող։',
          usage: 'Պահում է VM-ների սկավառակներ, ISO/սկավառակի պատկերներ և ձևանմուշներ։'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Կլաստերի միակցած Windows/Samba ընդհանուր ռեսուրս — բնույթով համօգտագործվող։',
          usage: 'Պահում է VM-ների սկավառակներ, ISO/սկավառակի պատկերներ և ձևանմուշներ։'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Հեռավոր ֆայլային համակարգ SSH-ի միջոցով — առանց NAS արտահանման կարիքի։',
          usage: 'Ճանապարհային քարտեզում։'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Բլոկային LUN-ներ IP-ի միջոցով՝ վրան համօգտագործվող LVM-ով։',
          usage: 'Միայն սկավառակներ — մեկ thin հատոր ամեն սկավառակի. չի պահում ISO պատկերներ և ձևանմուշներ։'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Բաշխված բլոկային սարքեր Ceph կլաստերի վրա։',
          usage: 'Միայն սկավառակներ — մեկ RBD պատկեր ամեն սկավառակի, բացվում է QEMU-ի կողմից բնիկ կերպով. չի պահում ISO պատկերներ։'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Ceph-ի բաշխված ֆայլային համակարգը՝ միջուկով միակցված կլաստերի վրա — բնույթով համօգտագործվող։',
          usage: 'Պահում է VM սկավառակներ, ISO/սկավառակի պատկերներ և ձևանմուշներ — dir ընտանիքը Ceph ֆայլային համակարգի վրա (cephx հավատարմագրերը պարտադիր են)։'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI LUN-ներ FibreChannel ֆաբրիկայի վրա — դասական FC SAN-ը։' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Նույն SCSI-ն FibreChannel-ի վրա, FC կադրերը՝ փաթեթավորված Ethernet-ի մեջ։' },

        // Կենդանի է ռաունդ #132-ից — բանալին contract-ի դրայվերի անունն է,
        // այնպես որ պահոցների ցուցակի չիպը լուծում է նույն գրառումը:
        'iscsi-lun': {
          name: 'iSCSI (ամբողջ LUN-ներ)',
          desc: 'iSCSI target-ը որպես ամբողջ LUN-ների կրող. յուրաքանչյուր սկավառակ LUN Է, հումքային փոխանցված հյուրին՝ առանց LVM-ի մեջտեղում։',
          usage: 'Միայն սկավառակներ. մեկ ամբողջ LUN մեկ սկավառակի համար, ընդունված ինչպես կա. ընդհանուր գրումով սկավառակների SAN տունը։'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (ամբողջ namespace-ներ)',
          desc: 'NVMe ենթահամակարգը որպես ամբողջ namespace-ների կրող. յուրաքանչյուր սկավառակ namespace Է, հումքային փոխանցված հյուրին։',
          usage: 'Միայն սկավառակներ. մեկ ամբողջ namespace մեկ սկավառակի համար, ընդունված ինչպես կա. ընդհանուր գրում՝ այո, SCSI persistent reservations՝ ոչ։'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Հեռավոր NVMe — ուղում SCSI չկա — պարզ TCP-ի վրա, վրան համօգտագործվող LVM-ով։',
          usage: 'Միայն սկավառակներ — մեկ thin հատոր ամեն սկավառակի. չի պահում ISO պատկերներ և ձևանմուշներ։'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Հեռավոր NVMe FibreChannel ֆաբրիկայի վրա։' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe FibreChannel ֆաբրիկայի վրա, որը FCoE-ն տանում է Ethernet-ի մեջ — FCoE և NVMe/FC շերտերը՝ իրար վրա։' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI՝ տվյալների ուղին տեղափոխված RDMA-ի վրա — ցանկացած ֆաբրիկա (InfiniBand, iWARP, RoCE)։ Փոխարինված է NVMe/RDMA-ով, դեռ առկա է զանգվածներում և ESXi-ում։' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Բնիկ SCSI RDMA-ի վրա, նախա-iSER դարաշրջանը. InfiniBand (ֆաբրիկայի հայտնաբերումով) և RoCE — վերապրում է հնացած HPC պահոցներում։' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Հեռավոր NVMe ցանկացած RDMA ֆաբրիկայի վրա — InfiniBand, iWARP, RoCE v1 և v2. մեկ կոնֆիգուրացիա, հանգույցն է ասում, թե որն ունի։' },
        s3: { name: 'S3', desc: 'S3-համատեղելի օբյեկտային պահոց — պատկերներ և կրկնօրինակներ։' }
      }
    },
    catalogs: {
      title: 'Կատալոգներ',
      createTitle: 'Ստեղծել կատալոգ',
      editTitle: 'Խմբագրել կատալոգը',
      docTitle: 'Կատալոգ',
      notFound: 'Այս կատալոգը գոյություն չունի (այլև՞ս)',
      scopeHint: 'Ով կարդում է այս սկոուպը, տեսնում է (և կարող է օգտագործել) կատալոգի ամեն ֆայլ',
      files: 'Ֆայլեր',
      noFiles: 'Ֆայլեր չկան',
      count: {
        iso: 'ISO',
        ctRootfs: 'CT ձևանմ.',
        vmTemplate: 'VM ձևանմ.',
        ociImage: 'OCI',
        firmwareOvmf: 'Որոնվածք'
      },

      // Համակարգային կատալոգը (ռաունդ #126). պլատֆորմի ներկառուցված օբյեկտների
      // տունը — ընթեռնելի բոլորի կողմից, գրելի ոչ մեկի:
      systemChip: 'համակարգային',
      systemTooltip: 'Համակարգային կատալոգ. հյուրընկալում է պլատֆորմի ներկառուցված օբյեկտները և չի կարող փոփոխվել'
    },

    // Կատալոգի ֆայլեր (ռաունդ K1, inventory v2e/v2g). կատալոգը կլաստերի իներտ
    // ֆայլային արտեֆակտների տունն է — մեկ ցուցակի բաղադրիչ, վերնագրերն ըստ kind-ի:
    catalogFiles: {
      catalog: 'Կատալոգ',
      kindLabel: 'Տեսակ',
      physicalSize: 'Ֆիզիկական չափ',
      virtualSize: 'Վիրտուալ չափ',

      // Ռաունդ K3 (#64) + K4 (#65, ova/ovf boot-survival քարտեզագրումով).
      // vm-template ֆայլը նյութականացվում է որպես գույքացուցակի VM ձևանմուշ:
      importTemplateAction: 'Ներմուծել որպես VM ձևանմուշ',
      importTemplateLegacy: 'Հայտարարված ձևաչափ չկա — օգտագործելի է որպես սկավառակի սերմ, ներմուծելի չէ',
      importTemplateTitle: 'Ներմուծել որպես VM ձևանմուշ',
      importTemplateSubmit: 'Ներմուծել',
      importTemplateError: 'Ներմուծումը չհաջողվեց',
      importTemplateHint: '.tvtpl փաթեթը դառնում է VM ձևանմուշ. մանիֆեստի սառեցված սարքաշարը՝ գումարած մեկ սկավառակ արխիվի ամեն մուտքի համար, ամեն մեկը ստուգված իր ստուգիչ գումարի դեմ։ NIC-երը և CD/DVD կրիչները արխիվի մաս չեն — ավելացրեք դրանք ներմուծումից հետո։',
      importTemplateQcow2Hint: 'Մերկ qcow2-ը դառնում է ՄԵԿ սկավառակով ձևանմուշ՝ հայտարարված լռելյայն սարքաշարով. linux պրոֆիլ, UEFI, 2 vCPU, 2048 MiB, բեռնում իր միակ սկավառակից։ Ճշգրտեք տեղակայման պահին։',
      importTemplateName: 'Ձևանմուշի անուն',
      importTemplateNameHint: 'Դատարկ = {name} (-import-<n>, եթե զբաղված է)',
      importTemplateStorage: 'Պահոց սկավառակների համար',
      importTemplateMetadataStorage: 'Մետատվյալների պահոց',
      importTemplateMetadataHint: 'Բլոկային պահոցը VM մետատվյալներ չի պահում (որոնվածք, varstore) — ընտրեք dir/nfs/cifs։',
      importTemplateStarted: 'Ներմուծումը սկսված է — ձևանմուշը կհայտնվի Ձևանմուշներ ներդիրում առաջադրանքի ավարտին։',

      // Խոսուն եզակի պիտակներ (#86). գտածոները և հաշվառումն ասում են,
      // ԻՆՉ է ֆայլը — ընդհանուր «Կատալոգի ֆայլ»-ը մնում է միայն որպես պահեստային:
      kind: {
        iso: 'ISO պատկեր',
        'ct-rootfs': 'CT rootfs',
        'vm-template': 'VM ձևանմուշ',
        'oci-image': 'OCI պատկեր',
        'firmware-ovmf': 'OVMF որոնվածք'
      },
      title: {
        iso: 'ISO պատկերներ',
        'ct-rootfs': 'CT ձևանմուշներ',
        'vm-template': 'VM ձևանմուշներ',
        'oci-image': 'OCI պատկերներ',
        'firmware-ovmf': 'OVMF որոնվածք'
      },
      createTitle: {
        iso: 'Ավելացնել ISO պատկեր',
        'ct-rootfs': 'Գրանցել CT ձևանմուշ',
        'vm-template': 'Ավելացնել VM ձևանմուշ',
        'oci-image': 'Ավելացնել OCI պատկեր',
        'firmware-ovmf': 'Ավելացնել OVMF որոնվածք'
      },
      formatHint: 'Ածանցված ընտրված ֆայլի ընդլայնումից — ուղղեք, եթե սխալ է գուշակել',
      tarballHint: 'Rootfs tarball ստանդարտ LXC ձևաչափով (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, կամ պարզ .tar)',
      ociArchiveHint: 'Docker-archive / oci-archive tarball (.tar կամ .tar.gz), օրինակ՝ docker save-ից',
      uploadResumeHint: 'Վերբեռնումն ընդհատվել է — ֆայլը սպասում է վերբեռնման. կրկին ուղարկեք նույն ֆայլով՝ շարունակելու համար',
      moveTitle: 'Տեղափոխել ֆայլը',
      moveHint: 'Երկու անկախ չափում. Կատալոգը տեղափոխում է հղումը (նույն id-ն, ոչ մի բայթ չի շարժվում, scope-ը դառնում է նշանակետ կատալոգինը), Պահոցը տեղափոխում է տվյալները — ամեն կապված պատճեն հետևում է, մերժվում է, քանի դեռ ֆայլն օգտագործման մեջ է։ Միասին ընտրելիս՝ նախ կատալոգը, հետո պահոցը։',
      moveCatalog: 'Նշանակետ կատալոգ',
      moveCatalogHint: 'Միայն հղումն է տուն փոխում. ֆայլը միացրած VM-ը պետք է կարողանա տեսնել նշանակետ կատալոգը',
      keepCurrent: 'Չփոխել',
      rehomed: 'Հղումը տեղափոխվեց ընտրված կատալոգ',
      copyAction: 'Պատճենել կատալոգի մեջ…',
      copyTitle: 'Պատճենել կատալոգի մեջ',
      copyLinkHint: 'Պատճենը նոր կապ է նույն տվյալներին — պահոցի վրա ոչինչ չի կրկնապատկվում։',
      copyCatalog: 'Նշանակետ կատալոգ',
      copyCatalogHint: 'Պատճենումն է այն ձևը, որով ֆայլը ճամփորդում է կատալոգների միջև',
      sameCatalog: 'Նույնը, ինչ աղբյուրինը',
      sharedObjectHint: 'Այս ֆայլի տվյալները կիսում են {count} կապված պատճեններ',
      deleteLastLink: 'Սա այս բովանդակության ՎԵՐՋԻՆ կապն է. տվյալները նույնպես կջնջվեն պահոցից։',
      deleteLinkOnly: 'Կհեռացվի միայն այս կապը — տվյալները մնում են՝ դեռ հասանելի մյուս կապված պատճեններով ({count})։',
      noCatalog: 'Դեռ ոչ մի կատալոգ չկա — ստեղծեք մեկը',
      inlineCatalogName: 'Կատալոգի անուն',

      // Պլատֆորմի ներկառուցված ֆայլերը (ռաունդ #126). storage null —
      // կարդացվում և կլոնավորվում են, երբեք move/delete/rename:
      embeddedChip: 'ներկառուցված',
      embeddedStorage: 'Ներկառուցված պլատֆորմում',
      embeddedNoMove: 'Պլատֆորմի ներկառուցված ֆայլ. այն ոչ մի պահոցի վրա չի ապրում — փոխարենը կլոնավորեք այն',
      embeddedCopyHint: 'Կլոնը նյութականացնում է ներկառուցված բայթերը իրական պահոցի վրա. ընտրեք նշանակետ պահոցն ու կատալոգը — պատճենը սովորական ֆայլ է',
      sourceEmbedded: 'Ներկառուցված պլատֆորմում',
      nodesRow: 'Առկայությունն ըստ հանգույցների',
      nodesSummary: '{total} հանգույցից {present}-ն ունի այն',
      nodePresent: 'առկա է',
      nodeMissing: 'բացակայում է',
      nodeUnknown: 'դեռ չի հաղորդվել',
      nodesHint: 'Ակտիվն ապրում է յուրաքանչյուր հանգույցի սկավառակի վրա (trantor-tvirt-assets փաթեթ). հանգույցը, որը չունի այն, չի կարող ոչ սահմանել VM այս firmware-ով, ոչ էլ մատուցել Guest Tools։ Հանգույցների միջև տարբեր տարբերակները նորմալ են փուլային թարմացման ընթացքում։',

      // Ներբեռնում (ռաունդ #108). բայթերը ճամփորդում են իրենց սեփական թույլտվությամբ:
      downloadAction: 'Ներբեռնել',
      downloadNotReady: 'Բովանդակությունը դեռ պատրաստ չէ — ներբեռնման համար պետք է պատրաստ ֆայլ',
      downloadDenied: 'Ձեր դերը չի ներառում catalog.download — բայթերի ներբեռնումը ֆայլի օգտագործումից առանձին իրավունք է',

      // Ռաունդ #156 (ստանդարտ երկխոսություն). մանրամասների երկխոսության պակասող
      // ընթերցման տողերը — կիսվող օբյեկտի փաստերը, հայտարարված ստուգիչ գումարը, օգտագործողները:
      objectRow: 'Պահոցի օբյեկտ',
      objectLinksRow: 'Կապված պատճեններ',
      declaredChecksum: 'Հայտարարված SHA-256',
      usedByRow: 'Օգտագործողը',
      usedByVms: 'VM-ներ',
      usedByDisks: 'Սկավառակներ',
      transferRow: 'Փոխանցում',
      storageLockHint: 'Փոխվում է միայն Տեղափոխել գործողությամբ'
    },

    // Ըստ պահոցի հաշվառումը (ռաունդ K1, inventory v2b #2). միայն ընթերցում,
    // ամեն օբյեկտ կառավարվում է իր բաժնից:
    objects: {
      action: 'Ուսումնասիրել բովանդակությունը',
      title: 'Պահոցի բովանդակությունը',
      hint: 'Միայն-ընթերցվող հաշվառում, թե ինչ է ապրում այս պահոցի վրա — ամեն օբյեկտ կառավարվում է իր բաժնից։',
      empty: 'Այս պահոցի վրա գրանցված ոչինչ չկա',
      loadError: 'Չհաջողվեց բեռնել բովանդակությունը',
      colDetail: 'Մանրամասն',
      manage: 'Կառավարել իր բաժնում',
      kind: {
        disk: 'Սկավառակ',
        catalogFile: 'Կատալոգի ֆայլ',
        ociBlob: 'OCI blob',
        checkpoint: 'Checkpoint',
        vmMetadata: 'VM մետատվյալներ',
        appRoot: 'Հավելվածի root',
        appVolume: 'Հավելվածի հատոր'
      }
    },
    inventory: {
      tabCatalogs: 'Կատալոգներ',
      storage: 'Պահոց',
      sizeGib: 'Չափ (GiB)',
      format: 'Ձևաչափ',
      size: 'Չափ',
      sourceType: 'Աղբյուր',
      sourceFile: 'Ֆայլի վերբեռնում',
      sourceUrl: 'Ներբեռնում URL-ից',
      file: 'Ֆայլ',
      url: 'URL',
      checksum: 'SHA-256 ստուգիչ գումար',
      checksumHint: 'Պարտադիր է. ներբեռնումը ստուգվում է այս SHA-256-ի դեմ',
      verifyChecksum: 'Ստուգել ստուգիչ գումարը',
      checksumOffHint: 'Ներբեռնումը կընդունվի առանց ստուգման — հաշվարկված SHA-256-ը միևնույն է գրանցվում է',
      uploading: 'Վերբեռնում…',
      move: {
        action: 'Տեղափոխել',
        diskTitle: 'Տեղափոխել սկավառակը',
        target: 'Նշանակետ պահոց',
        diskHint: 'Սկավառակը պահում է իր ինքնությունը. բայթերը ճամփորդում են ընտրված պահոց։ Այն օգտագործող VM-ը պետք է անջատված լինի. սնապշոթների առկայության դեպքում iSCSI կողմը մերժում է տեղափոխումը։',
        noTargets: 'Համատեղելի նշանակետ պահոց չկա',
        submit: 'Տեղափոխել',
        error: 'Տեղափոխումը մերժվեց'
      },
      clone: {
        action: 'Կլոնավորել',
        title: 'Կլոնավորել սկավառակը',
        name: 'Պատճենի անուն',
        storage: 'Նշանակետ պահոց',
        sameStorage: 'Նույնը, ինչ աղբյուրինը',
        linked: 'Կապված կլոն',
        linkedHint: 'Ակնթարթային qcow2 վրադիր՝ շղթայված աղբյուր սկավառակին (միայն qcow2 աղբյուրներ)։ Լռելյայնը լրիվ պատճենն է։',
        linkedCrossHint: 'Կապված կլոնը մնում է աղբյուրի պահոցի վրա. ընտրեք «Նույնը, ինչ աղբյուրինը»՝ այն ակտիվացնելու համար։',
        submit: 'Կլոնավորել',
        error: 'Կլոնավորումը մերժվեց'
      },
      copy: {
        action: 'Պատճենել',
        name: 'Պատճենի անուն',
        storage: 'Նշանակետ պահոց',
        sameStorage: 'Նույնը, ինչ աղբյուրինը',
        submit: 'Պատճենել',
        error: 'Պատճենումը մերժվեց'
      },
      taskStarted: 'Սկսված է — շարունակվում է որպես ֆոնային առաջադրանք',
      cephObjects: 'Անցնել օբյեկտի մանրամասներին Ceph-ում',
      phase: {
        ready: 'Պատրաստ',
        creating: 'Ստեղծվում է',
        'awaiting-upload': 'Վերբեռնման սպասում',
        downloading: 'Ներբեռնվում է',
        verifying: 'Ստուգվում է',
        deleting: 'Ջնջվում է',
        error: 'Սխալ',
        'in-use': 'Օգտագործման մեջ'
      }
    }
  }
}
